import React from 'react'

import { Paper, Box } from '@material-ui/core'

const CustomBox = ({ children }) => {
  return (
    <Paper elevation={3}>
      <Box p={3}>{children}</Box>
    </Paper>
  )
}

export default CustomBox
